<template>
  <!-- // 项目续约统计 -->
  <div class="app-container">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="120px"
      >
        <div class="back" @click="$router.go(-1)">
          <div><i class="el-icon-back"></i></div>
        </div>
        <el-form-item label="所属部门" prop="bmmc">
          <el-select
            ref="bmmc"
            v-model="listQuery.bmbh"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in zxlc.bmList"
              :key="item.bmbh"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="合同状态" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.htzt"
            placeholder="全部"
            clearable
            filterable
            size="small"
            class="filter-item"
          >
            <el-option
              v-for="item in zxlc.htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="一把手变更时间" prop="name">
          <el-date-picker
            v-model="listQuery.qssj"
            align="right"
            type="date"
            placeholder="选择日期"
            size="small"
            :picker-options="pickerStartTime"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="listQuery.jssj"
            align="right"
            type="date"
            placeholder="选择日期"
            size="small"
            :picker-options="pickerEndTime"
          >
          </el-date-picker>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList()"
            >搜 索</el-button
          >
        </span>
        <span style="margin-top: 4px; margin-left: 15px; display: inline-block">
          <el-button size="small" @click="reset()">重 置</el-button>
        </span>
      </el-form>
      <div style="margin: 10px 0">
        <el-button
          type="primary"
          size="small"
          @click="$router.push('/zxlc/ybsbg/ybsbgmxList')"
          >一把手变更明细</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 15px"
          size="small"
          @click="handlExportList()"
          >导出</el-button
        >
      </div>
    </div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="zxlc.ybsbgtjList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          :max-height="height"
          tooltip-effect="dark"
        >
          <el-table-column
            label="所属部门"
            prop="bmmc"
            min-width="150px"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <div
                @click="
                  $router.push({
                    path: '/zxlc/ybsbg/ybsbgmxList',
                    query: { bmbh: scope.row.bmbh },
                  })
                "
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.bmmc }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="一把手变更次数"
            prop="htdqxms"
            min-width="140px"
            align="center"
          >
            <template slot-scope="scope">
              <div
                v-if="scope.row.ybsbgcs && scope.row.ybsbgcs != 0"
                @click="handleToMxList(scope.row)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.ybsbgcs }}
              </div>
              <div v-else>{{ scope.row.ybsbgcs }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="完成正式拜访次数"
            prop="zsbfcs"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="各分公司项目执行正式拜访完成的次数"
                placement="top"
              >
                <div>
                  完成正式拜访次数&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="完成正式汇报次数"
            prop="zshbcs"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="各分公司项目执行正式汇报完成的次数"
                placement="top"
              >
                <div>
                  完成正式汇报次数&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="完成正式访谈次数"
            prop="zsftcs"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="各分公司项目执行正式访谈完成的次数"
                placement="top"
              >
                <div>
                  完成正式访谈次数&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="关键流程执行率"
            prop="gjlczxl"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="各分公司项目执行合计数/一把手变更次数*3"
                placement="top"
              >
                <div>
                  关键流程执行率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="一把手变更完成率"
            prop="ybsbgwcl"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="一把手变更流程全部完成的变更次数/一把手变更总次数"
                placement="top"
              >
                <div>
                  一把手变更完成率&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="未到岗的项目数"
            prop="wdgxms"
            min-width="160px"
            align="center"
          >
            <template slot="header">
              <el-tooltip
                class="item"
                effect="dark"
                content="提交一把手变更未到岗的项目"
                placement="top"
              >
                <div>
                  未到岗的项目数&nbsp;
                  <img src="@/img/tips.png" width="16" alt="" />
                </div>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div
                v-if="scope.row.wdgxms && scope.row.wdgxms != 0"
                @click="handleToWdgList(scope.row)"
                style="text-decoration: underline; cursor: pointer"
              >
                {{ scope.row.wdgxms }}
              </div>
              <div v-else>{{ scope.row.wdgxms }}</div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="zxlc.ybsbgtjList.total > 0"
          :total="zxlc.ybsbgtjList.total"
          :page.sync="listQuery.page"
          :limit.sync="listQuery.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="项目一把手变更未到岗明细"
      :visible.sync="viewDialog"
      width="90%"
      v-if="viewDialog"
      id="bbzqmx"
    >
      <WdgList ref="view" :mxParams="mxParams" :params="params"></WdgList>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination";
import MyLoading from "@/views/common/myLoading";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import WdgList from "./wdgList.vue";
import { ybsbgTjExport } from "@/api/zxlc";
import { formatMomentDate } from "@/utils/utils";

export default {
  // 列表分页
  name: "xmxyList",
  components: { Treeselect, Pagination, WdgList },
  computed: {
    ...mapGetters(["deptUser", "user", "zxlc"]),
    pickerStartTime() {
      return {
        disabledDate: (time) => {
          if (this.listQuery.jssj) {
            return time.getTime() > new Date(this.listQuery.jssj).getTime();
          }
        },
      };
    },
    pickerEndTime() {
      return {
        disabledDate: (time) => {
          if (this.listQuery.qssj) {
            return time.getTime() < new Date(this.listQuery.qssj).getTime();
          }
        },
      };
    },
  },
  data: () => {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },

      mxParams: {},
      height: 800,
      dialogTitle: null,
      listQuery: {
        bmbh: null,
        htzt: null,
        qssj: null,
        jssj: null,
        page: 1,
        pageSize: 50,
      },

      listLoading: false,
      total: 0,
      viewDialog: false,
      mxParams: {},
      params: {},
    };
  },

  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    if (this.zxlc.htztList.length == 0) {
      this.$store.dispatch("zxlc/fetchHtztListAction", {
        dictType: "htzt",
        type: 2,
      });
    }
    if (this.zxlc.bmList.length == 0) {
      this.$store.dispatch("zxlc/fetchBmListAction", { type: 2, range: 1 });
    }
    // if (this.user.bntqxzt == 2) {
    //   this.listQuery.bmbh = this.user.bmbh;
    // }
    this.getList();
  },
  methods: {
    reset() {
      this.listQuery = {
        ...this.listQuery,
        ...{ jssj: null, qssj: null, bmbh: null, htzt: null },
      };
    },
    getList() {
      this.listLoading = true;
      this.$store
        .dispatch("zxlc/fetchYbsbgtjListAction", {
          ...this.listQuery,
          qssj: this.listQuery.qssj
            ? formatMomentDate(this.listQuery.qssj)
            : null,
          jssj: this.listQuery.jssj
            ? formatMomentDate(this.listQuery.jssj)
            : null,
        })
        .then((res) => {
          if (res.code == 0) {
            this.listLoading = false;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 75;
          }
        });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    handleShowAdvice(e) {
      this.$refs.audit.handleShowAdvice(e);
    },
    handlExportList() {
      const { bmbh, htzt, qssj, jssj } = this.listQuery;
      ybsbgTjExport({ bmbh, htzt, qssj, jssj }).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath; // 组装a标签
          const elink = document.createElement("a"); // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    handleToWdgList(row, colTitle, status) {
      this.mxParams = row;
      const params = {
        ...this.listQuery,
        qssj: this.listQuery.qssj
          ? formatMomentDate(this.listQuery.qssj)
          : null,
        jssj: this.listQuery.jssj
          ? formatMomentDate(this.listQuery.jssj)
          : null,
        bmbh: row.bmbh,
      };
      this.params = params;
      this.$store.dispatch("zxlc/fetchWdgListAction", {
        ...params,
      });
      this.viewDialog = true;
    },
    handleToMxList(row) {
      this.$router.push({
        path: "/zxlc/ybsbg/ybsbgmxList",
        query: { bmbh: row.bmbh },
      });
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
::v-deep #bbzqmx .el-dialog__body {
  padding-top: 0;
  padding-bottom: 0;
}
#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
v-deep .el-loading-spinner {
  background: url("/src/img/my_loading.svg") no-repeat;
  background-size: 48px 48px;
}
</style>

